// extracted by mini-css-extract-plugin
module.exports = {"desktop":"LandaFinancingForm_desktop__LJ4Tw","mobile":"LandaFinancingForm_mobile__yhfbV"};